<template>
    <div class="map-home-nav">
        <a href="#">
            <img src="@/assets/logo.png" alt="logo" class="map-home-logo" draggable="false"
                oncontextmenu="return false;" />
        </a>
        <hr class="map-list-hr" />
        <p class="map-home-team" title="选择团队">
            <span class="map-home-team-name">{{ userInfo.nickName }}</span>
        </p>
        <MenuBar :level="0" />
        <div class="user-control">
            <div class="user-control-icon"></div>
            <div class="user-control-help user-control-btn" title="帮助"></div>
            <div class="user-control-info user-control-btn" title="消息"></div>
            <div class="user-control-quit user-control-btn" title="退出" @click="logout"></div>
        </div>
    </div>
</template>

<script>
import MenuBar from '../common/MenuBar.vue';
import { useMapStore } from '@/stores/mapStore';


export default {
    name: 'MapHomeNav',
    components: {
        MenuBar
    },
    data() {
        return {
            userInfo: {},
            mapStore: null,
        }
    },
    mounted() {

        this.mapStore = useMapStore();
        this.userInfo = this.mapStore.getUserInfo();

    },
    methods: {
       
        logout() {
            this.mapStore.userInfo = null;
            localStorage.removeItem("userInfo");
            localStorage.removeItem("token");
            localStorage.removeItem("selectAtlas");
            localStorage.removeItem("userJurisdiction");
            this.$router.push({ path: '/login' });
        }
    }
}

</script>

<style scoped>
.user-control div {
    float: left;
}

.user-control-icon {
    background-image: url('@/assets/images/icon/user.png');
    background-size: 100% 100%;
    cursor: pointer;
    border-radius: 50%;
    width: 38px;
    height: 38px;
}

.user-control-btn {
    background-image: url('@/assets/images/icon/nav-icon.png');
    cursor: pointer;
    margin-top: 11px;
}

.user-control-help {
    background-position: 51px 0;
    width: 16px;
    height: 16px;
}

.user-control-info {
    background-position: 33px 0;
    width: 16px;
    height: 16px;
}

.user-control-quit {
    background-position: 16px 0;
    width: 16px;
    height: 16px;
}



.user-control {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 60px;
    background-color: #122435;
    padding-top: 11px;
    display: flex;
    justify-content: space-around;
}

.map-home-nav {
    position: relative;
    height: 100%;
    flex: 0 0 200px;
    background-color: #1b2c3e;
    text-align: center;
    width: 200px;
    box-shadow: 1px 3px 5px #e0e0e0;
}

.map-home-logo {
    width: 143px;
    height: 32px;
    margin-top: 12px;
}

.map-list-hr {
    margin-top: 12px;
    margin-bottom: 12px;
    border-top: 1px solid #455362;
}

.map-home-team {
    width: 180px;
    height: 24px;
    margin: 0 auto;
    background-color: #122435;
    box-shadow: inset 0 1px 3px 0 rgba(0, 0, 0, 0.5);
    border-radius: 48px;
    font-size: 12px;
    cursor: pointer;
}

.map-home-team-name {
    color: #fff;
    display: inline-block;
    padding-left: 10px;
    padding-right: 10px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    opacity: 1;
    display: block;
    line-height: 24px;
    width: 88px;
    margin-left: 48px;
    text-align: left;
}
</style>